import { render, staticRenderFns } from "./KDropdownMenu.vue?vue&type=template&id=aba8c528&scoped=true&"
import script from "./KDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./KDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./KDropdownMenu.vue?vue&type=style&index=0&id=aba8c528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba8c528",
  null
  
)

export default component.exports